import type { DynamicFieldComponentProps } from '../../dynamic-form/dynamic-form.interfaces';
import ErrorLabel from '../../labels/error-label';
import FieldLabel from '../../labels/field-label';
import useTestTag from '../../../common/hooks/use-test-tag';
import Tooltip from '../../tooltip-component/tooltip.component';
import { DomElementAlignment, DomTargetPosition } from '../../enums';

export interface GeolocationValue {
  address: string;
  latitude: number;
  longitude: number;
}

const Geolocation = ({ name, label, error, value, labelStyles }: DynamicFieldComponentProps<GeolocationValue>) => {
  const tagCreator = useTestTag(label || name || '');
  const tooltipDescription = value ? `Latitude: ${value.latitude}, Longitude: ${value.longitude}` : '';

  return (
    <div>
      {label && name && (
        <div className="odin-flex">
          <FieldLabel label={label} name={name} labelStyles={labelStyles} />
        </div>
      )}
      <div ref={tagCreator('value')} className="odin-text-sm odin-py-1">
        <Tooltip
          description={tooltipDescription}
          tooltipClassName={'bg-mono-1 mt-1.5 ml-1.5 odin-text-sm'}
          tooltipTargetPosition={DomTargetPosition.BottomRight}
          tooltipAlignment={DomElementAlignment.TopRight}
          wrapperClassName={'odin-inline-flex'}
          tooltipZIndexCheck={true}
          disabled={!value}
        >
          {value?.address ?? ''}
        </Tooltip>
      </div>
      {error && <ErrorLabel>{error}</ErrorLabel>}
    </div>
  );
};

export default Geolocation;
